import {TeamPlanLeadFormEvent} from './team-plan-lead-form-event';

/**
 * Amplitude event fired on every Team Plan sign-up form submission attempt,
 * regardless of outcome. Always paired with either a succeeded or failed event.
 */
export class TeamPlanLeadFormSubmittedEvent extends TeamPlanLeadFormEvent {
    constructor(formId: string) {
        super('tp_lead_form_submitted', formId);
    }
}
